// src/App.tsx

import './index.scss';
import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Loader from './components/loader/loaders';
import EmptyLayout from './components/layouts/empty';
import { useAuthContext } from './context/authContext';
import { ProfilePage } from './page/profile';
import {SignIn} from "./page/auth/SingIn";
import {SignUp} from "./page/auth/SingUp";
import {AppLayout} from "./components/layouts/app";
import {DashboardPage} from "./page/dashboard/dashboard";

const App: React.FC = () => {
  const { accessToken } = useAuthContext();
  const isAuthenticated = accessToken;

  return (
    <React.Fragment>
      <BrowserRouter>
        <React.Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/" element={isAuthenticated ? <Navigate to="/dashboard" /> : <Navigate to="/signin" />} />

            <Route
              path="/signin"
              element={
                <EmptyLayout>
                  <SignIn />
                </EmptyLayout>
              }
            />
            <Route
              path="/signup"
              element={
                <EmptyLayout>
                  <SignUp />
                </EmptyLayout>
              }
            />
            <Route
              path="/dashboard"
              element={
                isAuthenticated ? (
                  <AppLayout>
                    <DashboardPage />
                  </AppLayout>
                ) : (
                  <Navigate to="/signin" />
                )
              }
            />
            <Route
              path="/profile"
              element={
                isAuthenticated ? (
                  <AppLayout>
                    <ProfilePage />
                  </AppLayout>
                ) : (
                  <Navigate to="/signin" />
                )
              }
            />
          </Routes>
        </React.Suspense>
      </BrowserRouter>
    </React.Fragment>
  );
};

export default App;
